"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _underscore = require("underscore");
var _utils = require("../../utils/");
var _constants = require("../../constants/");
var _Placeholders = require("@studio/constants/Placeholders");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * A lookup for camera arrangement on the featured screen layout.
 */
var featuredScreenConfigMap = {
  2: {
    col1Count: 2,
    col2Count: 0
  },
  3: {
    col1Count: 3,
    col2Count: 0
  },
  4: {
    col1Count: 4,
    col2Count: 0
  },
  5: {
    col1Count: 3,
    col2Count: 2
  },
  6: {
    col1Count: 3,
    col2Count: 3
  },
  7: {
    col1Count: 4,
    col2Count: 3
  },
  8: {
    col1Count: 4,
    col2Count: 4
  },
  9: {
    col1Count: 5,
    col2Count: 4
  },
  10: {
    col1Count: 5,
    col2Count: 5
  }
};

/**
 *
 * @param {Array} sources
 * @param  featuredTypes
 * @param {{}} sourceStyle
 */
function featuredBuilder(sources, featuredTypes) {
  var sourceStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var camSources = (0, _utils.getCameraSources)(sources).filter(function (source) {
    return source.type !== _constants.SCREEN_PRESENTER;
  });
  var allowedFeaturedTypes = !Array.isArray(featuredTypes) ? [featuredTypes] : featuredTypes;
  var featuredSource = (0, _underscore.find)(sources, function (source) {
    return allowedFeaturedTypes.includes(source.type);
  }) || _objectSpread(_objectSpread({}, _utils.PLACEHOLDER_SOURCE), {}, {
    value: (0, _Placeholders.getPlaceholderUrl)('500x300')
  });
  var camSourceCount = Math.min(camSources.length, _utils.MAX_CAMERA_COUNT);
  var config = featuredScreenConfigMap[camSourceCount];
  var tileWidth;
  var tileHeight;
  var featuredWidth;
  var featuredHeight;
  var topLeftTileMargin;
  var leftLeftTileMargin;
  var topRightTileMargin;
  var rightLeftTileMargin;
  var leftRightTileMargin;
  var tileMargin = _utils.SCENE_HEIGHT * 4 / 378;
  if (camSourceCount < 5) {
    featuredWidth = _utils.SCENE_WIDTH * 494 / 672;
    featuredHeight = featuredWidth / _utils.SCENE_ASPECT_RATIO;
    var rawTileHeight = camSourceCount === 1 ? featuredHeight * 188 / 278 : featuredHeight / camSourceCount;
    var availableTileHeight = featuredHeight - tileMargin * (camSourceCount - 1);
    tileWidth = _utils.SCENE_WIDTH * 130 / 672;
    tileHeight = camSourceCount === 1 ? featuredHeight * 188 / 278 : availableTileHeight / camSourceCount;
    leftLeftTileMargin = _utils.SCENE_WIDTH * 20 / 672;
    rightLeftTileMargin = _utils.SCENE_WIDTH * 8 / 672;
    topLeftTileMargin = (_utils.SCENE_HEIGHT - rawTileHeight * camSourceCount) / 2;
  } else {
    featuredWidth = _utils.SCENE_WIDTH * 418 / 672;
    featuredHeight = featuredWidth / _utils.SCENE_ASPECT_RATIO;
    var _rawTileHeight = _utils.SCENE_HEIGHT * 278 / 378 / config.col1Count;
    var _availableTileHeight = _utils.SCENE_HEIGHT * 278 / 378 - tileMargin * (config.col1Count - 1);
    tileWidth = _utils.SCENE_WIDTH * 100 / 672;
    tileHeight = _availableTileHeight / config.col1Count;
    leftLeftTileMargin = _utils.SCENE_WIDTH * 20 / 672;
    rightLeftTileMargin = _utils.SCENE_WIDTH * 7 / 672;
    leftRightTileMargin = rightLeftTileMargin;
    topLeftTileMargin = (_utils.SCENE_HEIGHT - _rawTileHeight * config.col1Count) / 2;
    topRightTileMargin = (_utils.SCENE_HEIGHT - _rawTileHeight * (camSourceCount - config.col1Count)) / 2;
  }
  var camLayers = camSources.map(function (source, sourceIndex) {
    var sourceNum = sourceIndex + 1;
    var tilePositioning = {
      top: topLeftTileMargin,
      left: leftLeftTileMargin
    };
    if (camSourceCount > 1) {
      var isCol1 = sourceNum <= config.col1Count;
      tilePositioning = isCol1 ? {
        top: sourceIndex * (tileHeight + tileMargin) + topLeftTileMargin,
        left: leftLeftTileMargin
      } : {
        top: (sourceIndex - config.col1Count) * (tileHeight + tileMargin) + topRightTileMargin,
        left: leftLeftTileMargin + tileWidth + rightLeftTileMargin + featuredWidth + leftRightTileMargin
      };
    }
    var tileStyles = _objectSpread(_objectSpread({}, tilePositioning), {}, {
      width: tileWidth,
      height: tileHeight
    });
    var bannerPosition = (0, _utils.getPresenterBannerPosition)(tileStyles);
    return {
      _id: source._id,
      source: source,
      layer: {
        animation: _objectSpread(_objectSpread({}, _utils.HARD_CUT_ANIMATION), {}, {
          animate: _objectSpread(_objectSpread({}, _utils.HARD_CUT_ANIMATION.animate), {}, {
            width: tileWidth,
            height: tileHeight,
            top: tilePositioning.top,
            left: tilePositioning.left
          })
        }),
        style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _utils.COMMON_CAMERA_STYLES.styles), {}, {
          width: tileWidth,
          height: tileHeight,
          zIndex: sourceNum,
          position: 'absolute',
          mediaStyle: _objectSpread(_objectSpread({}, _utils.COMMON_CAMERA_STYLES.mediaStyles), {}, {
            height: tileHeight,
            width: tileWidth
          })
        }, tilePositioning), sourceStyle), {}, {
          bannerStyles: _objectSpread(_objectSpread(_objectSpread({}, bannerPosition), _utils.extraPresenterBannerStyles), {}, {
            zIndex: sourceNum
          }),
          bannerAnimation: _objectSpread(_objectSpread({}, _utils.PRESENTER_BANNER_ANIMATION), {}, {
            animate: _objectSpread(_objectSpread({}, _utils.PRESENTER_BANNER_ANIMATION.animate), {}, {
              top: bannerPosition.top - 40,
              left: bannerPosition.left
            })
          })
        })
      }
    };
  });
  var featuredTopOffset = (_utils.SCENE_HEIGHT - featuredHeight) / 2;
  var featuredLeftOffset = leftLeftTileMargin + tileWidth + rightLeftTileMargin;
  var featuredLayer = {
    _id: featuredSource._id,
    source: featuredSource,
    layer: {
      animation: _objectSpread(_objectSpread({}, _utils.DEFAULT_ANIMATION), {}, {
        initial: _objectSpread(_objectSpread({}, _utils.DEFAULT_ANIMATION.initial), {}, {
          top: featuredTopOffset,
          left: featuredLeftOffset + featuredWidth
        }),
        animate: _objectSpread(_objectSpread({}, _utils.DEFAULT_ANIMATION.animate), {}, {
          width: featuredWidth,
          top: featuredTopOffset,
          height: featuredHeight,
          left: featuredLeftOffset
        }),
        exit: {
          opacity: 0,
          top: featuredTopOffset,
          left: featuredLeftOffset + featuredWidth
        }
      }),
      style: _objectSpread({
        zIndex: 'auto',
        width: featuredWidth,
        position: 'absolute',
        height: featuredHeight,
        top: featuredTopOffset,
        left: featuredLeftOffset,
        mediaStyle: {
          objectFit: 'contain'
        }
      }, sourceStyle)
    }
  };
  var layers = camLayers.concat([featuredLayer]);
  return {
    layers: layers,
    description: '',
    title: 'featured',
    _id: 'sceneFeatured',
    // TODO: remove as it is unnecessary and unused and probably will be confused w/ mongo object IDs
    style: _objectSpread({}, _utils.COMMON_SCENE_STYLES)
  };
}
var _default = exports["default"] = featuredBuilder;